import Icon from 'veui/components/Icon'
import { IconTimesCircleSolid } from 'dls-icons-vue'

Icon.register('times-circle-solid', IconTimesCircleSolid)
